import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import type { ReviewAgentSummary } from '../steps/useReviewAgentSummary';

// TODO: cleanup with cp_annotation_createproject_agent ff

const LIST_SEPARATOR = ', ';

interface SummaryRowProps {
  label: string;
  value: string;
}

const SummaryRow = ({ label, value }: SummaryRowProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', gap: theme.spacing(4) }}>
      <Typography variant="body1" color="text.secondary" sx={{ width: '220px', flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </Box>
  );
};

export interface AnnotationAgentSummaryProps {
  summary: ReviewAgentSummary;
}

/** The Review "Annotation agent" section: one row while off, the saved setup while on. */
export const AnnotationAgentSummary = ({ summary }: AnnotationAgentSummaryProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const none = formatMessage({ id: 'createProjectWizard.step.reviewAndCreate.agent.none' });
  const label = (key: string) =>
    formatMessage({ id: `createProjectWizard.step.reviewAndCreate.agent.${key}` });
  const joinOrNone = (items: string[]) => (items.length > 0 ? items.join(LIST_SEPARATOR) : none);

  return (
    <Card elevation={2}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
        <SummaryRow
          label={label('status.label')}
          value={label(summary.isOn ? 'status.on' : 'status.off')}
        />
        {summary.isOn && (
          <>
            <SummaryRow label={label('model.label')} value={summary.modelName ?? '--'} />
            <SummaryRow label={label('basePrompt.label')} value={label('basePrompt.value')} />
            <SummaryRow label={label('concepts.label')} value={String(summary.conceptCount)} />
            <SummaryRow
              label={label('specialNotes.label')}
              value={joinOrNone(summary.conceptNamesWithNotes)}
            />
            <SummaryRow
              label={label('sections.label')}
              value={joinOrNone(summary.sectionHeadings)}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
